import type { CompletedSteps } from './valuation.models';

export interface ComparableMatch {
  apn: string;
  /** 1-indexed rank within this comparable's own category (cap_rate/sale/rent). */
  ranking: number;
  /** 1-indexed rank across the union of all three categories -- distinct from
   * `ranking`. Consistent for the same apn across every category list it's in. */
  overall_ranking: number;
  explanation: string;
  distance_miles: number;
  property_address: string | null;
  city: string | null;
  county_name: string | null;
  property_type: string | null;
  number_of_units: number | null;
  unit_count_diff: number | null;
  year_built: number | null;
  year_built_diff: number | null;
  last_sale_date: string | null;
  last_sale_price: number | null;
  cap_rate: number | null;
  cap_rate_available: boolean;
  avg_rent_per_unit: number | null;
  affordable_type: string | null;
  sales_tier: number | null;
  rent_tier: number | null;
  cap_tier: number | null;
  included: boolean;
}

export interface ComparablesSubject {
  property_address: string | null;
  county: string | null;
  units: number | null;
  year_built: number | null;
}

export interface ComparablesResponse {
  cap_rate_comparables: ComparableMatch[];
  sale_comparables: ComparableMatch[];
  rent_comparables: ComparableMatch[];
  data_notes: string[];
  generated_at: string;
  subject: ComparablesSubject;
  progress: CompletedSteps;
}

export type ComparableCategory = 'cap_rate_comparables' | 'sale_comparables' | 'rent_comparables';

export interface ComparableCategoryDef {
  key: ComparableCategory;
  label: string;
}

export const COMPARABLE_CATEGORIES: ComparableCategoryDef[] = [
  { key: 'cap_rate_comparables', label: 'Cap Rate Comparables' },
  { key: 'sale_comparables', label: 'Sale Comparables' },
  { key: 'rent_comparables', label: 'Rent Comparables' },
];

export interface UpdateComparableSelectionRequest {
  comparable_id: string;
  included: boolean;
}
